import { motion } from 'framer-motion';

const TermsOfService = () => {
    return (
        <section className='min-h-screen bg-surface-muted py-20 px-6'>
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className='max-w-4xl mx-auto bg-white rounded-card shadow-premium p-10 lg:p-16'
            >
                <h1 className='text-4xl font-black text-primary mb-8 tracking-tight'>Terms of Service</h1>
                <div className='prose prose-slate max-w-none space-y-8 text-gray-600 font-medium'>
                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>1. Agreement to Terms</h2>
                        <p>By accessing or using our website, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, then you may not access the service.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>2. User Obligations</h2>
                        <p>You agree not to use the service for any unlawful purpose or to conduct any activity that would constitute a civil or criminal offense. You are responsible for maintaining the confidentiality of your account login information.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>3. Returns & Refunds</h2>
                        <p>Our Return Policy, which is available on our website, is part of these Terms. Please review it to understand your rights regarding returns and refunds.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>4. Limitation of Liability</h2>
                        <p>In no event shall Shalimar Helmet, nor its directors, employees, or partners, be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>5. Governing Law</h2>
                        <p>These Terms shall be governed and construed in accordance with the laws of the State, without regard to its conflict of law provisions.</p>
                    </section>

                    <section className='pt-8 border-t border-surface-border'>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>6. Changes to Terms</h2>
                        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of any significant changes.</p>
                    </section>
                </div>
            </motion.div>
        </section>
    );
};

export default TermsOfService;
